import { STABLE_LANGUAGE } from '../../../lib/core/_constants/constants';
import { environment } from '../../environments';

export class Language {
  locale: string;
  flag: string;
  country: string;
  language: string;
}

const languageData = [
  { locale: 'fr', flag: 'fr', country: 'France', language: 'Français' },
  { locale: 'en', flag: 'us', country: 'United States', language: 'English' },
  { locale: 'de', flag: 'de', country: 'Germany', language: 'Deutsch' },
  { locale: 'es', flag: 'es', country: 'Spain', language: 'Español' },
  { locale: 'ja', flag: 'ja', country: 'Japan', language: '日本' },
  { locale: 'ko', flag: 'ko', country: 'Korea', language: '한국인' },
  { locale: 'pt', flag: 'pt', country: 'Portugal', language: 'Português' },
  { locale: 'it', flag: 'it', country: 'Italia', language: 'Italian' },
  { locale: 'ru', flag: 'ru', country: 'Russia', language: 'русский' },
  { locale: 'tr', flag: 'tr', country: 'Turkey', language: 'Türkçe' },
  { locale: 'vi', flag: 'vi', country: 'Vietnam', language: 'Tiếng Việt' },
  { locale: 'zh-Hans', flag: 'zh-Hans', country: 'China', language: '中文' },
  { locale: 'ar', flag: 'ar', country: 'Saudi Arabia', language: 'عربي' },
  { locale: 'pl', flag: 'pl', country: 'Poland', language: 'Polska' },
  {
    locale: 'th-TH',
    flag: 'th-TH',
    country: 'Thailand',
    language: 'ประเทศไทย',
  },
];

export const languages = (): Language[] => {
  return languageData.filter((language) => {
    return (
      environment.features.newLanguages ||
      STABLE_LANGUAGE.includes(language.locale)
    );
  });
};
